import React from "react";
import { Alert } from "antd";

const MarginFeedbackAlert = ({ dealerPrice, transporterPrice, lowMarginAlertCallback, goodMarginAlertCallback }) => {
  if (
    dealerPrice === null ||
    dealerPrice === undefined ||
    transporterPrice === null ||
    transporterPrice === undefined
  ) {
    return null;
  }

  let dealerPriceNum = Number(dealerPrice);
  let transporterPriceNum = Number(transporterPrice);

  if (isNaN(Number(dealerPrice)) || isNaN(Number(transporterPrice))) {
    return null;
  }

  dealerPriceNum = dealerPrice < 0 ? 0 : dealerPrice;
  transporterPriceNum = transporterPrice < 0 ? 0 : transporterPrice;

  const validDealerPrice = dealerPrice >= 0;

  const marginDollars = (dealerPriceNum - transporterPriceNum).toFixed(2);
  const marginPercent = ((marginDollars / (dealerPrice || 1)) * 100).toFixed(2);
  const marginColor =
    marginPercent >= 20 && validDealerPrice ? "success" : marginPercent >= 15 && validDealerPrice ? "warning" : "error";

  if (marginColor === "error") {
    lowMarginAlertCallback?.();
  } else {
    goodMarginAlertCallback?.();
  }

  return (
    <Alert
      showIcon
      message={<strong>{`Margin: $${marginDollars}${validDealerPrice ? ` (${marginPercent}%)` : ""}`}</strong>}
      type={marginColor}
    />
  );
};

export default MarginFeedbackAlert;
